import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  Inject,
  PLATFORM_ID,
  HostListener,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {
  navLinks = [
    { id: 'manjocarn', label: 'Manjocarn' },
    { id: 'restaurant', label: 'Restaurant' },
    { id: 'carte', label: 'La carte' },
    { id: 'evenements', label: 'Événements' },
    { id: 'activites', label: 'Activités' },
    { id: 'payer', label: 'Payer' },
    { id: 'instagram', label: 'Instagram' },
  ];

  // Barre d'onglets mobile : 7 sections ne tiennent pas dans une bottom bar
  // (3-5 items max pour rester lisible/accessible au pouce). On garde les 4
  // sections les plus consultées et on renvoie le reste vers l'overlay
  // "Plus" existant plutôt que d'entasser 7 icônes peu discernables.
  bottomTabs = [
    { id: 'manjocarn', label: 'Accueil', icon: 'home' },
    { id: 'restaurant', label: 'Resto', icon: 'restaurant' },
    { id: 'carte', label: 'Carte', icon: 'menu_book' },
    { id: 'evenements', label: 'Events', icon: 'event' },
  ];

  activeSection = this.navLinks[0].id;
  menuOpen = false;
  scrolled = false;

  get isMoreActive(): boolean {
    return !this.bottomTabs.some((tab) => tab.id === this.activeSection);
  }

  private observer: IntersectionObserver | null = null;

  toggleMenu(): void {
    this.setMenuOpen(!this.menuOpen);
  }

  closeMenu(): void {
    this.setMenuOpen(false);
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.closeMenu();
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    if (!isPlatformBrowser(this.platformId)) return;
    this.scrolled = window.scrollY > 48;
  }

  private setMenuOpen(open: boolean): void {
    this.menuOpen = open;
    if (isPlatformBrowser(this.platformId)) {
      document.body.classList.toggle('mj-no-scroll', open);
    }
  }

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private titleService: Title,
    private metaService: Meta,
  ) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.titleService.setTitle("Manjocarn — La Guinguette au bord de l'eau");
      this.metaService.updateTag({
        name: 'description',
        content:
          "Manjocarn, guinguette au bord de l'eau. Cuisine locale, magret de canard, événements festifs. Ouvert en saison.",
      });
    }
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.initSectionObserver();
      this.onWindowScroll();
    }
  }

  ngOnDestroy() {
    this.observer?.disconnect();
    this.setMenuOpen(false);
  }

  private initSectionObserver(): void {
    const sections = document.querySelectorAll('.mj-section');
    if (!sections.length) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.activeSection = entry.target.id;
          }
        }
      },
      { rootMargin: '-40% 0px -55% 0px', threshold: 0 },
    );

    sections.forEach((section) => this.observer?.observe(section));
  }
}
